import JsonLd from 'components/JsonLd';
import { ORGANIZATION_NAME } from 'const/organization';

const priceValidUntil = (() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().split('T')[0];
})();

const getAvailability = (inStock) => {
  if (!inStock) return 'https://schema.org/OutOfStock';
  const lower = inStock.toLowerCase();
  if (lower.includes('наличи') || lower.includes('есть')) {
    return 'https://schema.org/InStock';
  }
  return 'https://schema.org/OutOfStock';
};

const ProductJsonLd = ({ product }) => {
  const description = product.seo?.seo_description
    || (product.additional_parameters || []).map(i => `${i.label}: ${i.value}`).join(', ')
    || '';

  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.seo?.h1 || product.title,
    "image": product.image ? [product.image] : [],
    "sku": product.article,
    "description": description,
    "brand": {
      "@type": "Brand",
      "name": ORGANIZATION_NAME
    },
    "url": product.seo?.canonical_url || window.location.href,
    "offers": {
      "@type": "Offer",
      "price": product.min_price,
      "priceCurrency": "RUB",
      "availability": getAvailability(product.in_stock),
      "url": product.seo?.canonical_url || window.location.href,
      "priceValidUntil": priceValidUntil
    }
  };

  return <JsonLd data={schema} />;
};

export default ProductJsonLd;
